import { ContractProvider } from '../admin/plan-versions/plan-version.type';
import { PlanDetailsAngeplusButton } from './PlanDetailsAngeplusButton';
import { PlanDetailsGsadminButton } from './PlanDetailsGsadminButton';

type PlanDetailsPrimaryButtonProps = {
  planVersionId?: string | number;
  contractProvider?: ContractProvider;
};

export const PlanDetailsPrimaryButton = (
  props: PlanDetailsPrimaryButtonProps,
) => {
  if (props.contractProvider === 'angeplus') {
    return <PlanDetailsAngeplusButton planVersionId={props.planVersionId} />;
  }

  return <PlanDetailsGsadminButton planVersionId={props.planVersionId} />;
};
